import {AgentContext} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';

type CreativeTemplatePageContext = {
  creativeTemplateInfo: {
    templateId: number;
    templateName: string;
    formats: string[];
  } | null;
};

export default function creativeTemplatePageContext(
  store: CLStore,
): AgentContext<CreativeTemplatePageContext> {
  return {
    title: 'Creative Template Page',
    getter: (): CreativeTemplatePageContext => {
      const template = store.getState().creativeTemplatePage.template;

      if (!template) {
        return {creativeTemplateInfo: null};
      }

      return {
        creativeTemplateInfo: {
          templateId: template.id,
          templateName: template.name,
          formats: template.formats.map((format) => format.format.formatString),
        },
      };
    },

    formatter: ({currentContext}) => {
      if (!currentContext) {
        return null;
      }

      if (!currentContext.creativeTemplateInfo) {
        return 'The user is currently not viewing a creative template.';
      }

      const {formats, templateId, templateName} = currentContext.creativeTemplateInfo;

      return (
        `The user is currently viewing the creative template: ${templateName} (ID: ${templateId})` +
        (formats.length ? ` with formats: ${formats.join(', ')}` : ' without formats.')
      );
    },
  };
}
